import { createContext, useContext, useEffect, useState } from "react";
import { http } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      setUser(false);
      return false;
    }
  };

  useEffect(() => {
    (async () => {
      await fetchMe();
      setLoading(false);
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    return data; // { mfa_required, user } — la sessione (cookie HttpOnly) nasce solo dopo il secondo fattore
  };

  const completeMfa = async () => fetchMe();

  const logout = async () => {
    try { await http.post("/auth/logout"); } catch {}
    setUser(false);
  };

  const refresh = async () => fetchMe();

  return (
    <AuthCtx.Provider value={{ user, loading, login, completeMfa, logout, setUser, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
